import { makeType, parseOptions, initLog } from "../core/base"

import {
    // Dispatcher,
    Stream
} from "../core/dispatcher-flyd"

// import Dispatcher from '../core/dispatcher-flyd';

import {
    modelChanged
    // getKey
} from "./common.js"

import UI from "../core/ui"

// export default class Tabs extends UI.Base {
const proto = {
    name: "Tabs",

    options: {},

    parseOptions,
    initLog,

    init() {
        return {
            current: -1,
            next: 0
        }
    },

    update(msg, model) {
        switch (msg.type) {
            case "click":
                msg.preventDefault ()
                model.next = this.dom.findByRole ("tab").indexOf (msg.target)
                // this.log.info("next:", model.next, "target:", msg.target)
                break
        }
        return model
    },

    select(model, role) {
        let panels = this.dom.findByRole (role)
        if (panels.length > 0) {
            panels.forEach (p => p.removeClass ("selected"))
            panels[model.next].addClass ("selected")
        }
    },

    view(model) {
        if (model.current !== model.next) {
            this.select (model, "panel")
            this.select (model, "tab")
            this.select (model, "tab-item")
            model.current = model.next
        }
        return model
    },

    initialize(dom) {
        this.dom = dom
        this.initLog ()
        // this.log.enable();

        this.parseOptions ()

        let currentModel = this.init ()
        currentModel = this.view (currentModel)

        this.eventStream = new Stream ()

        this.eventStream.map (msg => {
            let model = { ...currentModel }
            model = this.update (msg, model)

            if (modelChanged (currentModel, model)) {
                model = this.view (model)
            }
            currentModel = model
        })

        dom.findByRole ("tab").forEach (t => {
            t.addEvent ("click", this.eventStream.stream)
        })
    }
}

const Tabs = makeType (proto)

export default Tabs

UI.register ("tabs", Tabs)
